import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=30704ad7&scoped=true&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"
import style0 from "@/styles/super.css?vue&type=style&index=0&id=30704ad7&prod&scoped=true&lang=css&"
import style1 from "./Policy.vue?vue&type=style&index=1&id=30704ad7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30704ad7",
  null
  
)

export default component.exports